/**
 * Hook to check if current user is an admin based on crew record
 * Fetches admin status from the backend instead of Clerk organization
 */

import { useCrewGetMe } from '@/lib/hooks'

/**
 * Check if current user is an admin
 * @returns { isAdmin: boolean; isLoaded: boolean }
 */
export function useIsAdmin() {
  const { data: crew, isLoading } = useCrewGetMe()

  return {
    isAdmin: crew?.isAdmin ?? false,
    isLoaded: !isLoading,
  }
}
